// extracted by mini-css-extract-plugin
export default {"control":"control_control__Sypag","button":"control_button__a2980"};